import { useContext } from 'react';
import { WorkSpacesC } from 'src/contexts/WorkspacesContext';

const useWorkspaces = () => useContext(WorkSpacesC);

export default useWorkspaces;
